import { render, staticRenderFns } from "./wine-catalogue-page.vue?vue&type=template&id=f16b34ac"
import script from "./wine-catalogue-page.vue?vue&type=script&lang=js"
export * from "./wine-catalogue-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports